"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.MarkAndLabel = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _findKey = _interopRequireDefault(require("lodash/findKey"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var RC = _interopRequireWildcard(require("./RadioCheckboxParts"));
var _Icon = _interopRequireDefault(require("../Icons/Icon"));
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Mark = (0, _styledComponents["default"])(RC.Mark).withConfig({
  displayName: "CheckboxParts__Mark",
  componentId: "sc-1es0pzq-0"
})(["border-radius:", ";> div{opacity:0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}"], function (props) {
  return props.theme.fields.checkBorderRadius;
});
var Label = RC.Label;
var Wrapper = (0, _styledComponents["default"])(RC.Wrapper).withConfig({
  displayName: "CheckboxParts__Wrapper",
  componentId: "sc-1es0pzq-1"
})(["input:checked ~ ", " ", "{background-color:", ";> div{opacity:1;transition:all 0.2s ease-in-out;}}"], Label, Mark, function (props) {
  return (0, _helpers.getColor)(props, "color", "radioCheckBackground");
});
exports.Wrapper = Wrapper;
var MarkAndLabel = function MarkAndLabel(_ref) {
  var htmlFor = _ref.htmlFor,
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? "Check" : _ref$iconName,
    children = _ref.children,
    isHighlighted = _ref.isHighlighted;
  var theme = (0, _styledComponents.useTheme)();
  var checkmarkSize = (0, _findKey["default"])(theme.iconSizes, function (value) {
    return value === theme.fields.radioCheckIconSize;
  }) || "base";
  return /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: htmlFor,
    noContent: !children,
    isHighlighted: isHighlighted
  }, children, /*#__PURE__*/_react["default"].createElement(Mark, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: iconName,
    size: ["m", "l"].includes(checkmarkSize) ? "s" : "xs",
    color: "inherit"
  })));
};
exports.MarkAndLabel = MarkAndLabel;
MarkAndLabel.propTypes = {
  htmlFor: _propTypes["default"].string,
  iconName: _propTypes["default"].string,
  children: _propTypes["default"].node,
  isHighlighted: _propTypes["default"].bool
};